import React from 'react';
import { intl } from 'i18n';

import { random } from 'global/utils';
import { Button } from 'ui/components';
import { ROUTES } from 'global/constants';
import { SignInLink } from 'elements';
import { WrappedMessage, getHomeVariationExperimentValue } from 'utils';
import { analyticsInstance, EVENT_NAMES } from 'tracking';
import uiMessages from 'ui/components/displayMessages';
import amgenFoundation from 'assets/images/amgen-foundation.png';
import joinUsHexLeft from 'assets/images/join-hex-left.svg';
import joinUsHexRight from 'assets/images/join-hex-right.svg';

import { testimonials } from '../Home';
import { TestimonialSection } from '../Testimonials';
import messages from '../../displayMessages';

interface CommentContentProps {
  curriculumSlug: string;
  countryCode: string;
  isUserLoggedIn: boolean;
}

export const CommonContent = ({
  curriculumSlug,
  countryCode,
  isUserLoggedIn,
}: CommentContentProps) => {
  const experimentVariation = getHomeVariationExperimentValue(curriculumSlug);
  return (
    <>
      <div className='empower-teaching'>
        <h2>
          {intl.formatMessage(messages.homeVariationPageEmpowerSectionHeading)}
        </h2>
        <div className='empower-teaching-row'>
          <div className='empower-teaching-col'>
            <img src='/assets/images/icons/home-explore.svg' alt='' />
            <h3>
              {intl.formatMessage(
                messages.homeVariationPageEmpowerExploreHeading
              )}
            </h3>
            <p>
              {intl.formatMessage(messages.homeVariationPageEmpowerExploreText)}
            </p>
          </div>
          <div className='empower-teaching-col'>
            <img src='/assets/images/icons/home-create.svg' alt='' />
            <h3>
              {intl.formatMessage(
                messages.homeVariationPageEmpowerCreateHeading
              )}
            </h3>
            <p>
              {intl.formatMessage(messages.homeVariationPageEmpowerCreateText)}
            </p>
          </div>
          <div className='empower-teaching-col'>
            <img src='/assets/images/icons/home-share.svg' alt='' />
            <h3>
              {intl.formatMessage(
                messages.homeVariationPageEmpowerShareHeading
              )}
            </h3>
            <p>
              {intl.formatMessage(messages.homeVariationPageEmpowerShareText)}
            </p>
          </div>
        </div>
        <div className='empower-teaching-row'>
          <Button
            className='empower-teaching-signup-btn'
            label={messages.homeVariationPageEmpowerSignUpBtnLabel}
            href={ROUTES.General.SIGN_UP}
            onClick={() => {
              analyticsInstance.track(
                EVENT_NAMES.NewHomePageEmpowerSectionSignUpButtonClicked(
                  experimentVariation
                ),
                {
                  curriculum_slug: curriculumSlug,
                  country: countryCode,
                  experiment_variation: experimentVariation,
                  button_text: intl.formatMessage(
                    messages.homeVariationPageEmpowerSignUpBtnLabel
                  ),
                  url: window.location.toString(),
                }
              );
            }}
            icon='arrow-right-thin'
            iconPosition='right'
            btnStyle='unstyled'
          />
        </div>
      </div>
      <div className='testimonials section navy'>
        <TestimonialSection
          testimonials={testimonials}
          firstIdx={Math.floor(random(Date.now()) * testimonials.length)}
        />
      </div>
      <div className='sponsor-section'>
        <h2>{intl.formatMessage(messages.sponsorHeading)}</h2>
        <img
          src={amgenFoundation}
          alt={intl.formatMessage(messages.sponsorAltTag)}
        />
        <p>{intl.formatMessage(messages.sponsorText1)}</p>
        <p>{intl.formatMessage(messages.sponsorText2)}</p>
        <Button
          className='amgen-foundation-btn'
          label={messages.interactiveSponsorButtonLabel}
          href={ROUTES.Organizations.PROFILE_SLUG('AmgenFoundation')}
          onClick={() => {
            analyticsInstance.track(
              EVENT_NAMES.NewHomePageSponsorProfileButtonClicked(
                experimentVariation
              ),
              {
                curriculum_slug: curriculumSlug,
                country: countryCode,
                experiment_variation: experimentVariation,
                button_text: intl.formatMessage(
                  messages.interactiveSponsorButtonLabel
                ),
                url: window.location.toString(),
              }
            );
          }}
          btnStyle='outline'
        />
      </div>
      <div className='join-us section navy-gradient'>
        <div className='background left'>
          <img src={joinUsHexLeft} alt='' />
        </div>
        <div className='join-text'>
          <h2>{intl.formatMessage(messages.joinUsHeading)}</h2>
          <SignInLink
            to={ROUTES.Explore.HOME}
            onClick={() => {
              analyticsInstance.track(
                EVENT_NAMES.NewHomePageJoinUsSignUpButtonClicked(
                  experimentVariation
                ),
                {
                  curriculum_slug: curriculumSlug,
                  country: countryCode,
                  experiment_variation: experimentVariation,
                  button_text: intl.formatMessage(uiMessages.uiSignUp),
                  url: window.location.toString(),
                }
              );
            }}
            signIn={ROUTES.General.SIGN_UP}
            className='btn btn-outline-primary section-button'
            isUserLoggedIn={isUserLoggedIn}
          >
            <WrappedMessage message={uiMessages.uiSignUp} />
          </SignInLink>
        </div>
        <div className='background right'>
          <img src={joinUsHexRight} alt='' />
        </div>
      </div>
    </>
  );
};

export default CommonContent;
